import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["step", "sum", "title", "isRedesign"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getLocalCurrencyStr } from '@beef/utils';
import { EStatus } from "../../constants";
import { findFirst } from "../../utils/arrays";
import { templateParser } from "../../utils/strings";
import { EResult } from "../RequestStatus/RequestStatusRedesign/types";
import { onPaymentModalAnalyticsHandler } from "./analytics";
export var converter = function converter(_ref) {
  var _props$img, _props$img2;
  var step = _ref.step,
    sum = _ref.sum,
    title = _ref.title,
    isRedesign = _ref.isRedesign,
    props = _objectWithoutProperties(_ref, _excluded);
  var onMount = function onMount() {
    onPaymentModalAnalyticsHandler({
      step: step,
      sum: sum,
      title: title
    });
  };
  var isSuccess = step !== EStatus.Error;
  var _title = findFirst([isRedesign && isSuccess && sum && templateParser('+{{sum}}', {
    sum: getLocalCurrencyStr(sum)
  }), title, (_props$img = props.img) === null || _props$img === void 0 ? void 0 : _props$img.alt]);
  var description = findFirst([isRedesign && isSuccess && sum && (title || ((_props$img2 = props.img) === null || _props$img2 === void 0 ? void 0 : _props$img2.alt)), props.description]);
  return _objectSpread(_objectSpread({
    onMount: onMount
  }, props), {}, {
    isRedesign: isRedesign,
    title: _title,
    description: description,
    result: findFirst([step === EStatus.Error && EResult.Error, step === EStatus.Success && EResult.Success])
  });
};